module.exports = __webpack_public_path__ + "static/media/Portable_Bridge_Station_01.a118ac86.jpg";